// removed by extract-text-webpack-plugin
module.exports = {"footerContainer":"footerContainer__vgrcU","copyrightContainer":"copyrightContainer__-uJG4","copyright":"copyright__bggOp","buildingVisions":"buildingVisions__3fmSC","corporateContainer":"corporateContainer__3Usl_","copyrightmobile":"copyrightmobile__2hDhD","connectContainer":"connectContainer__13V4n","container":"container__2RXPq","socialContainer":"socialContainer__1elj5"};


//////////////////
// WEBPACK FOOTER
// ./components/footer/style.scss
// module id = R99g
// module chunks = 5